var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 52.1355H20.625C8.18123 52.1355 2.86456 46.8188 2.86456 34.375V20.625C2.86456 8.18129 8.18123 2.86462 20.625 2.86462H34.375C46.8187 2.86462 52.1354 8.18129 52.1354 20.625V34.375C52.1354 46.8188 46.8187 52.1355 34.375 52.1355ZM20.625 6.30212C10.0604 6.30212 6.30206 10.0605 6.30206 20.625V34.375C6.30206 44.9396 10.0604 48.698 20.625 48.698H34.375C44.9396 48.698 48.6979 44.9396 48.6979 34.375V20.625C48.6979 10.0605 44.9396 6.30212 34.375 6.30212H20.625Z",
    fill: "url(#paint0_linear_1_1518)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 36.1624C21.5646 36.1624 21.1292 36.002 20.7854 35.6583L15.0792 29.952C13.7271 28.5999 13.7271 26.4229 15.0792 25.0708L20.7854 19.3645C21.45 18.6999 22.55 18.6999 23.2146 19.3645C23.8792 20.0291 23.8792 21.1291 23.2146 21.7937L17.5084 27.4999L23.2146 33.2291C23.8792 33.8937 23.8792 34.9937 23.2146 35.6583C22.8709 35.9791 22.4354 36.1624 22 36.1624Z",
    fill: "url(#paint1_linear_1_1518)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 36.1625C32.5646 36.1625 32.1292 36.0021 31.7854 35.6584C31.1208 34.9938 31.1208 33.8938 31.7854 33.2292L37.4917 27.5L31.7854 21.7709C31.1208 21.1063 31.1208 20.0063 31.7854 19.3417C32.45 18.6771 33.55 18.6771 34.2146 19.3417L39.9208 25.048C41.2729 26.4 41.2729 28.5771 39.9208 29.9292L34.2146 35.6355C33.8938 35.9792 33.4354 36.1625 33 36.1625Z",
    fill: "url(#paint2_linear_1_1518)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1518",
    x1: 27.5,
    y1: 2.86462,
    x2: 27.5,
    y2: 52.1355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#64C2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#095898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1518",
    x1: 18.8891,
    y1: 18.8661,
    x2: 18.8891,
    y2: 36.1624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#64C2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#095898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1518",
    x1: 36.1109,
    y1: 18.8433,
    x2: 36.1109,
    y2: 36.1625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#64C2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#095898"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTec);
export default __webpack_public_path__ + "static/media/tec.1d71d98d8d2bee7005725f5cde80a610.svg";
export { ForwardRef as ReactComponent };